/**
 * B.H. Copyright (c) 2026 Yemot HaMashiach Ltd.
 * All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * Yemot HaMashiach Ltd. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with Yemot HaMashiach Ltd.
 *
 * Unauthorized copying of this file, via any medium, is strictly prohibited.
 */
import React from 'react';
import WatchSystem from '../WatchSystem/WatchSystem';
import PageShell from '../PageShell';

export default function ClockSystem(props) {
  return (
    <PageShell title="מערכת שעון" subtitle="הגדרות לוחות זמנים ושעונים">
      <WatchSystem isDesktop={props.isDesktop} entityType="community" />
    </PageShell>
  );
}
